module.exports = __webpack_public_path__ + "img/drag.6739002a.svg";